import { WSModal, WSModalCustomProps } from "@wingspanhq/fe-component-library";
import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { useRequirementHistoryResources } from "../hooks/useRequirementHistoryResources";
type Props = {
  requirement: PayeeRequirement;
} & WSModalCustomProps<void>;

export const ModalRequirementHistory: React.FC<Props> = ({
  requirement,
  ...modalProps
}) => {
  const scope = useRequirementHistoryResources(requirement);
  // The requirement itself is read from the expanded payer's account on the
  // contractor-details route, so its audit trail has to be read from the same
  // account or the timeline comes back empty. Resolves to undefined off that
  // route, which is the caller's own account.
  const xWingspanAccount = useXWingspanPayerId();

  return (
    <WSModal title="Requirement history" {...modalProps}>
      <ResourceHistory resources={scope} xWingspanAccount={xWingspanAccount} />
    </WSModal>
  );
};
